// detection adapted from https://github.com/matteobad/detect-autofill
const appendStyle = (name) => {
    const style = window.document.createElement('style');
    style.innerHTML = `
        @keyframes autofillStart {}
        @keyframes autofillCancel {}

        input[name="${name}"]:-webkit-autofill {
            animation-name: autofillStart;
        }

        input[name="${name}"]:not(:-webkit-autofill) {
            animation-name: autofillCancel;
        }
    `;
    window.document.head.appendChild(style);
};
/**
 * Manage an input element when its value is data-autocompleted
 * by the browser in the following steps:
 * - add [data-autocompleted] attribute from event.target
 * - create 'autocomplete' cancelable CustomEvent
 * - dispatch the Event
 */
export const autocompleteFn = (element) => {
    if (element.hasAttribute('data-autocompleted'))
        return;
    element.setAttribute('data-autocompleted', '');
    var event = new window.CustomEvent('autocomplete', {
        bubbles: true,
        cancelable: true,
        detail: null
    });
    // no autofill if preventDefault is called
    if (!element.dispatchEvent(event)) {
        element.value = '';
    }
};
/**
 * Manage an input element when its data-autocompleted value is
 * removed by the browser in the following steps:
 * - remove [data-autocompleted] attribute from event.target
 * - create 'autocomplete' non-cancelable CustomEvent
 * - dispatch the Event
 */
export const cancelAutocomplete = (element) => {
    if (!element.hasAttribute('data-autocompleted'))
        return;
    element.removeAttribute('data-autocompleted');
    element.dispatchEvent(new window.CustomEvent('autocomplete', {
        bubbles: true,
        cancelable: false,
        detail: null
    }));
};
/**
 * Handler for -webkit based browser that listen for a custom
 * animation create using the :pseudo-selector in the stylesheet.
 * Works with Chrome, Safari
 */
export const useOnAnimationStart = (name, event, autocompleteFn, cancelAutocomplete) => {
    const target = event.target;
    if ((target === null || target === void 0 ? void 0 : target.name) !== name) {
        return;
    }
    event.animationName === 'autofillStart' ? autocompleteFn(target) : cancelAutocomplete(target);
};
/**
 * Handler for non-webkit based browser that listen for input
 * event to trigger the autocomplete-cancel process.
 * Works with Firefox, Edge, IE11
 */
export const useOnInput = (name, event, autocomplete, cancelAutocomplete) => {
    const inputEvent = event;
    const target = event.target;
    if ((target === null || target === void 0 ? void 0 : target.name) !== name) {
        return;
    }
    inputEvent.inputType === 'insertReplacementText' || !('data' in inputEvent)
        ? autocomplete(target)
        : cancelAutocomplete(target);
};
const detectAutofill = (name, useOnAnimationStart, useOnInput, callback) => {
    appendStyle(name);
    window.document.addEventListener('animationstart', (event) => useOnAnimationStart(name, event, autocompleteFn, cancelAutocomplete), true);
    window.document.addEventListener('input', (event) => useOnInput(name, event, autocompleteFn, cancelAutocomplete), true);
    window.document.addEventListener('autocomplete', callback, true);
};
export default detectAutofill;
//# sourceMappingURL=index.js.map